export default "__VITE_ASSET__e90314d0__"